import ContractsCargoTaxiListParams, {
  ContractsCargoTaxiListParamsOrder,
} from "../../../../../common/services/contracts/cargo-taxi/list/contracts-cargo-taxi-list-params";
import CargoCargoTaxiContractListingFilter, {
  CargoCargoTaxiContractListingActiveFilter,
  CargoCargoTaxiContractListingCargoCompanyFilter,
  CargoCargoTaxiContractListingTaxiCorporationFilter,
} from "./types/cargo-cargo-taxi-contract-listing-filter";
import CargoCargoTaxiContractListingFilterType from "./types/cargo-cargo-taxi-contract-listing-filter-type";
import CargoCargoTaxiContractListingSortKey from "./types/cargo-cargo-taxi-contract-listing-sort-key";

const createOrder = (
  sortKey: CargoCargoTaxiContractListingSortKey | null,
): ContractsCargoTaxiListParamsOrder | undefined => {
  const definition: Record<
    CargoCargoTaxiContractListingSortKey,
    ContractsCargoTaxiListParamsOrder
  > = {
    [CargoCargoTaxiContractListingSortKey.DISTANCE_RATE_ASC]:
      ContractsCargoTaxiListParamsOrder.DISTANCE_RATE_ASC,
    [CargoCargoTaxiContractListingSortKey.DISTANCE_RATE_DESC]:
      ContractsCargoTaxiListParamsOrder.DISTANCE_RATE_DESC,
    [CargoCargoTaxiContractListingSortKey.VALID_SINCE_ASC]:
      ContractsCargoTaxiListParamsOrder.VALID_SINCE_ASC,
    [CargoCargoTaxiContractListingSortKey.VALID_SINCE_DESC]:
      ContractsCargoTaxiListParamsOrder.VALID_SINCE_DESC,
    [CargoCargoTaxiContractListingSortKey.VALID_TO_ASC]:
      ContractsCargoTaxiListParamsOrder.VALID_TO_ASC,
    [CargoCargoTaxiContractListingSortKey.VALID_TO_DESC]:
      ContractsCargoTaxiListParamsOrder.VALID_TO_DESC,
  };

  return sortKey ? definition[sortKey] : undefined;
};

const create = (
  page: number,
  pageSize: number,
  filters: CargoCargoTaxiContractListingFilter[],
  sortKey: CargoCargoTaxiContractListingSortKey | null,
): ContractsCargoTaxiListParams => {
  const active = filters.find(
    (filter) => filter.type == CargoCargoTaxiContractListingFilterType.ACTIVE,
  )?.value as CargoCargoTaxiContractListingActiveFilter["value"] | undefined;

  return {
    order: createOrder(sortKey),
    page: page,
    pageSize: pageSize,
    active: active,
    cargoCompanyName: filters.find(
      (filter) =>
        filter.type === CargoCargoTaxiContractListingFilterType.CARGO_COMPANY,
    )?.value as
      | CargoCargoTaxiContractListingCargoCompanyFilter["value"]
      | undefined,
    taxiCorporationName: filters.find(
      (filter) =>
        filter.type ===
        CargoCargoTaxiContractListingFilterType.TAXI_CORPORATION,
    )?.value as
      | CargoCargoTaxiContractListingTaxiCorporationFilter["value"]
      | undefined,
  };
};

const cargoTaxiContractListingLoadParamsFactory = {
  create,
};

export default cargoTaxiContractListingLoadParamsFactory;
